import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchVehicleCategory,
  initializeVehicleCategoryScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleCategory,
  deleteVehicleCategory,
  saveVehicleCategoryTableState,
} from "../../../redux/actions/vehicles/vehicleCategory";
import VehicleCategory from '../../../component/Vehicles/VehicleCategory';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
function VehicleCategoryScreen(props) {
  const {
    fetchVehicleCategory,
    initVehicleCategoryScreen,
    showPageLevelLoader,
    vehicleCategoryListview,
    paginationInfo,
    exportVehicleCategory,
    isVehicleCategoryExportError,
    isVehicleCategoryExportSuccess,
    screenPermissions,
    isLoading,
    deleteVehicleCategory,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    isVehicleCategoryDeleteSuccess,
    isVehicleCategoryDeleteError,
    savedTableState,
    saveVehicleCategoryTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initVehicleCategoryScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchVehicleCategory(savedParams);
    } else {
      fetchVehicleCategory({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchVehicleCategory(props);
  };

  const handleTableStateChange = (tableState) => {
    saveVehicleCategoryTableState(tableState);
  };

  const handleCreateVehicleCategory = () => {
    navigate(APP_URLS.VEHICLE_CATEGORY.CREATE);
  }
  const editVehicleCategoryRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_CATEGORY.EDIT, {
      id,
    });
    navigate(path);
  };
  const copyVehicleCategoryRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_CATEGORY.COPY, {
      id,
    });
    navigate(path);
  };
  const vehicleCategory = {
    handleCreateVehicleCategory,
    exportVehicleCategory,
    isVehicleCategoryExportError,
    isVehicleCategoryExportSuccess,
    editVehicleCategoryRoute,
    copyVehicleCategoryRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteVehicleCategory,
    isVehicleCategoryDeleteSuccess,
    isVehicleCategoryDeleteError,
    fetchVehicleCategorys: loadLazyData,
    tableData: {
      columns: vehicleCategoryListview?.columns,
      rows: vehicleCategoryListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleCategory
        {...vehicleCategory}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleCategoryScreen: () => dispatch(initializeVehicleCategoryScreen()),
    fetchVehicleCategory: (payload) => dispatch(fetchVehicleCategory(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleCategory: (payload) => dispatch(exportVehicleCategory(payload)),
    deleteVehicleCategory: (payload) => dispatch(deleteVehicleCategory(payload)),
    saveVehicleCategoryTableState: (payload) => dispatch(saveVehicleCategoryTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleCategoryCreateSuccess: selectFromVehicleCategoryReducer(
      state,
      "isVehicleCategoryCreateSuccess"
    ),
    vehicleCategoryListview: selectFromVehicleCategoryReducer(
      state,
      "vehicleCategoryListview"
    ),
    showPageLevelLoader: selectFromVehicleCategoryReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleCategoryReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleCategoryReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleCategoryReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleCategoryExportError: selectFromVehicleCategoryReducer(
      state,
      "isVehicleCategoryExportError"
    ),
    isVehicleCategoryExportSuccess: selectFromVehicleCategoryReducer(
      state,
      "isVehicleCategoryExportSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromVehicleCategoryReducer(state, "shouldOpenDeleteConfirmationPopup"),
    isVehicleCategoryDeleteSuccess: selectFromVehicleCategoryReducer(state, "isVehicleCategoryDeleteSuccess"),
    isVehicleCategoryDeleteError: selectFromVehicleCategoryReducer(state, "isVehicleCategoryDeleteError"),
    isLoading: selectFromVehicleCategoryReducer(state, "isLoading"),
    savedTableState: selectFromVehicleCategoryReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleCategoryReducer = (state, path) => {
  return selectVehicleCategoryReducer(state)[path];
};

const selectVehicleCategoryReducer = ({ vehicleCategoryReducer }) => {
  return vehicleCategoryReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleCategoryScreen);
